// Bound decoding/download pressure when several rows enter view together.
// Unmounted virtual rows remove their queued request or abort its live fetch.
let active = 0;
const pending: Array<() => void> = [];
const MAX_ACTIVE = 3;

export function scheduleDrawingThumbnail<T>(work: () => Promise<T>, signal: AbortSignal): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let started = false;
    const abort = () => {
      if (started) return;
      const index = pending.indexOf(start);
      if (index >= 0) pending.splice(index, 1);
      reject(new DOMException('Thumbnail request cancelled', 'AbortError'));
    };
    const start = () => {
      if (signal.aborted) { abort(); return; }
      started = true;
      signal.removeEventListener('abort', abort);
      active += 1;
      void Promise.resolve().then(work).then(resolve, reject).finally(() => {
        active -= 1;
        while (active < MAX_ACTIVE && pending.length) pending.shift()?.();
      });
    };
    if (signal.aborted) { abort(); return; }
    signal.addEventListener('abort', abort, { once: true });
    if (active < MAX_ACTIVE) start();
    else pending.push(start);
  });
}
